import axios from 'axios';
import config from '../config/backend.config'

const BASE_URL = config.backendurl;

const StorageType = Object.freeze({
  Standard: "Standard",
  Companion: "Companion",
  WebAR: "WebAR",
});

function upload(formData, accesstoken, onProgress) {
  const url = `${BASE_URL}/models`;
  let config = {
    onUploadProgress(progressEvent) {
      var percentCompleted = Math.round((progressEvent.loaded * 100) /
        progressEvent.total);

      if (onProgress) onProgress(percentCompleted)
      return percentCompleted;
    },
    headers: { 'Authorization': "bearer " + accesstoken }
  };
  return axios.post(url, formData, config)
    .then();
}

function getModel(guid, accesstoken) {
  const url = `${BASE_URL}/models/${guid}`;
  let
    headers = { 'Authorization': "bearer " + accesstoken }

  return axios({ url: url, method: 'GET', responseType: 'blob', headers: headers })
    .then(x => new Blob([ x.data ]))
}

function getModels(accesstoken, storageType) {
  return axiosGet('models?storage-type=' + storageType, accesstoken);
}

function getSubscriptionInfo(accesstoken) {
  return axiosGet('subscription', accesstoken);
}

function deleteModel(guid) {
  const url = `${BASE_URL}/models/${guid}`
  return axios.delete(url).then(x => x.data)
}

function renameModel(guid, name, accesstoken) {
  const url = `${BASE_URL}/models/${guid}`
  let config = {
    headers: { 'Authorization': "bearer " + accesstoken }
  }
  return axios.post(url, { Guid: guid, Name: name }, config)
    .then();
}

function activateModelAsync(modelId) {
  const url = `${BASE_URL}/models/${modelId}/is-active`

  return axios.put(url)
    .then();
}

function deactivateModelAsync(modelId) {
  const url = `${BASE_URL}/models/${modelId}/is-active`

  return axios.delete(url)
    .then();
}

function getThumbnail(guid, accesstoken) {
  return axiosGet(`thumbnails/${guid}`, accesstoken);
}

function getUsersList(accesstoken) {
  return axiosGet('users', accesstoken);
}

function addUser(username, role, accesstoken) {
  const url = `${BASE_URL}/users`;
  let config = {
    headers: { 'Authorization': "bearer " + accesstoken }
  }
  return axios.post(url, { Username: username, Role: role }, config)
    .then();
}

function removeUser(username, accesstoken) {
  const url = `${BASE_URL}/users`;
  let config = {
    headers: { 'Authorization': "bearer " + accesstoken },
    data: { username: username }
  }
  return axios.delete(url, config)
    .then();
}

function getUserInfo(accesstoken) {
  return axiosGet('users/me', accesstoken);
}

function getBrochures(accesstoken) {
  return axiosGet('companion/brochures', accesstoken);
}

function postBrochure(accessToken, formData) {
  const url = `${BASE_URL}/companion/brochures`;

  const config = {
    headers: {
      "Authorization": "bearer " + accessToken
    }
  };

  return axios.post(url, formData, config)
    .then();
}

function deleteBrochure(accessToken, brochureId) {
  const url = `${BASE_URL}/companion/brochures/${brochureId}`;

  const config = {
    headers: {
      "Authorization": "bearer " + accessToken
    }
  };

  return axios.delete(url, config)
    .then();
}

async function getWebAREmbeds() {
  return await getAsync('webar/embeds');
}

async function postWebAREmbed(formData) {
  const url = `${BASE_URL}/webar/embeds`;

  return await axios.post(url, formData, config);
}

async function deleteWebAREmbed(embedId) {
  const url = `${BASE_URL}/webar/embeds/${embedId}`;

  return await axios.delete(url, config);
}

async function getWebAREmbedCode(embedId, width, height) {
  return await getAsync(`webar/get-embed-code?embedId=${embedId}&width=${width}&height=${height}`);
}

function axiosGet(address, accesstoken) {
  const url = `${BASE_URL}/${address}`;
  let config = {
    headers: { 'Authorization': "bearer " + accesstoken }
  }
  return axios.get(url, config).then(x => x.data);
}

async function getModelsAsync(storageType) {
  return await getAsync('models?storage-type=' + storageType)
}

async function deleteModelAsync(guid) {
  console.log("Deleting: " + guid)

  return await deleteAsync(`models/${guid}`)
}

async function getSubscriptionInfoAsync() {
  return await getAsync('subscription');
}

async function registerNewUserAsync() {
  const url = `${BASE_URL}`

  return await axios.post(url + '/events/on-user-signed-up')
}

async function getThumbnailAsync(guid) {
  return await getAsync(`thumbnails/${guid}`)
}

async function getQrCodeAsync(url) {
  return await getAsync(`qrcodes?url=${encodeURIComponent(url)}`)
}

async function getAsync(address) {
  const url = `${BASE_URL}/${address}`
  try {
    const response = await axios.get(url)

    return response.data
  } catch (error) {
    console.log('axios error for ' + address)
    console.log(error)
    console.log(error.response)

    throw error
  }
}

async function deleteAsync(address) {
  const url = `${BASE_URL}/${address}`

  try {
    const response = await axios.delete(url)

    return response.data
  } catch (error) {
    console.log('axios error for ' + address)
    console.log(error)
    console.log(error.response)

    throw error
  }
}

export {
  StorageType,
  upload,
  getModels,
  getModel,
  deleteModel,
  getThumbnail,
  getSubscriptionInfo,
  getUsersList,
  addUser,
  removeUser,
  getUserInfo,
  renameModel,
  getBrochures,
  postBrochure,
  deleteBrochure,
  getModelsAsync,
  deleteModelAsync,
  getSubscriptionInfoAsync,
  registerNewUserAsync,
  getThumbnailAsync,
  activateModelAsync,
  deactivateModelAsync,
  getQrCodeAsync,
  getWebAREmbeds,
  postWebAREmbed,
  deleteWebAREmbed,
  getWebAREmbedCode,
}
